// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"d250feeb","178":"c03b69ee","204":"442ace3c","268":"4c5add27","350":"cc35d6a0","575":"d9542bcc","830":"3e8f5d52"}[chunkId] + ".chunk.js";
};